import script from "./CarCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CarCard.vue?vue&type=script&setup=true&lang=js"

import "./CarCard.vue?vue&type=style&index=0&id=74d21640&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d21640"]])

export default __exports__